import plantingIcon from "../assets/images/bureau-veritas/planting.png";
import mineIcon from "../assets/images/bureau-veritas/mine.png";
import saveTheWorldIcon from "../assets/images/bureau-veritas/save-the-world.png";
import { normalizeDocumentIds } from "./customPageDocuments";

export const DEFAULT_ROLE3_SIDEBAR_ITEMS = [
  { id: "home", label: "Home", type: "route", path: "/home", enabled: true, sortOrder: 0, iconClass: "bx bx-home" },
  { id: "resources", label: "Resources", type: "route", path: "/resources", enabled: true, sortOrder: 1, iconClass: "bx bx-aperture" },
  { id: "contact-info", label: "Contact Info", type: "scroll", scrollTarget: "contact-info", enabled: true, sortOrder: 2, iconClass: "bx bx-message" },
  { id: "support", label: "Support", type: "scroll", scrollTarget: "support-info", enabled: true, sortOrder: 3, iconClass: "bx bx-help-circle" },
];

/**
 * Preset Boxicons for the company portal sidebar editor. The app CSS also bundles MDI, Font
 * Awesome, and Dripicons (`_icons.scss`), but only Boxicons `bx` / `bxs` class strings are
 * accepted by the API — browse https://boxicons.com for any other names to paste if we add
 * a custom field later. Empty `value` = Auto.
 */
const SIDEBAR_ICON_PRESET_GROUPS_INNER = [
  {
    group: "Default",
    options: [{ value: "", label: "Auto (from type & path)" }],
  },
  {
    group: "Home & navigation",
    options: [
      { value: "bx bx-home", label: "Home" },
      { value: "bx bx-home-alt", label: "Home alt" },
      { value: "bx bx-home-smile", label: "Home smile" },
      { value: "bx bx-home-circle", label: "Home circle" },
      { value: "bx bx-menu", label: "Menu" },
      { value: "bx bx-grid", label: "Grid" },
      { value: "bx bx-grid-alt", label: "Grid alt" },
      { value: "bx bx-list-ul", label: "List" },
      { value: "bx bx-list-ol", label: "Numbered list" },
      { value: "bx bx-directions", label: "Directions" },
      { value: "bx bx-compass", label: "Compass" },
      { value: "bx bx-current-location", label: "Current location" },
      { value: "bx bx-left-arrow", label: "Left arrow" },
      { value: "bx bx-right-arrow", label: "Right arrow" },
      { value: "bx bx-up-arrow", label: "Up arrow" },
      { value: "bx bx-down-arrow", label: "Down arrow" },
      { value: "bx bx-chevron-left", label: "Chevron left" },
      { value: "bx bx-chevron-right", label: "Chevron right" },
      { value: "bx bx-chevron-up", label: "Chevron up" },
      { value: "bx bx-chevron-down", label: "Chevron down" },
      { value: "bx bx-undo", label: "Undo" },
      { value: "bx bx-revision", label: "History / revision" },
    ],
  },
  {
    group: "User & people",
    options: [
      { value: "bx bx-user", label: "User" },
      { value: "bx bx-user-circle", label: "User circle" },
      { value: "bx bx-user-check", label: "User check" },
      { value: "bx bx-user-plus", label: "User plus" },
      { value: "bx bx-group", label: "Group" },
      { value: "bx bx-id-card", label: "ID card" },
      { value: "bx bx-female", label: "Female" },
      { value: "bx bx-male", label: "Male" },
    ],
  },
  {
    group: "Files & content",
    options: [
      { value: "bx bx-book", label: "Book" },
      { value: "bx bx-book-content", label: "Book content" },
      { value: "bx bx-book-open", label: "Book open" },
      { value: "bx bx-book-reader", label: "Book reader" },
      { value: "bx bx-bookmark", label: "Bookmark" },
      { value: "bx bx-bookmarks", label: "Bookmarks" },
      { value: "bx bx-file", label: "File" },
      { value: "bx bx-file-blank", label: "File blank" },
      { value: "bx bx-file-find", label: "File find" },
      { value: "bx bx-file-pdf", label: "File PDF" },
      { value: "bx bx-folder", label: "Folder" },
      { value: "bx bx-archive", label: "Archive" },
      { value: "bx bx-collection", label: "Collection" },
      { value: "bx bx-copy", label: "Copy" },
      { value: "bx bx-paste", label: "Paste" },
      { value: "bx bx-clipboard", label: "Clipboard" },
      { value: "bx bx-notepad", label: "Notepad" },
      { value: "bx bx-news", label: "News" },
      { value: "bx bx-article", label: "Article" },
      { value: "bx bx-purchase-tag", label: "Tag" },
      { value: "bx bx-duplicate", label: "Duplicate" },
    ],
  },
  {
    group: "Media",
    options: [
      { value: "bx bx-image", label: "Image" },
      { value: "bx bx-images", label: "Images" },
      { value: "bx bx-image-add", label: "Image add" },
      { value: "bx bx-camera", label: "Camera" },
      { value: "bx bx-camera-off", label: "Camera off" },
      { value: "bx bx-video", label: "Video" },
      { value: "bx bx-music", label: "Music" },
      { value: "bx bx-play", label: "Play" },
      { value: "bx bx-play-circle", label: "Play circle" },
      { value: "bx bx-stop", label: "Stop" },
      { value: "bx bx-movie", label: "Movie" },
    ],
  },
  {
    group: "Communication",
    options: [
      { value: "bx bx-envelope", label: "Envelope" },
      { value: "bx bx-mail-send", label: "Mail send" },
      { value: "bx bx-message", label: "Message" },
      { value: "bx bx-message-dots", label: "Message dots" },
      { value: "bx bx-message-rounded", label: "Message rounded" },
      { value: "bx bx-chat", label: "Chat" },
      { value: "bx bx-phone", label: "Phone" },
      { value: "bx bx-phone-call", label: "Phone call" },
      { value: "bx bx-link-external", label: "External link" },
      { value: "bx bx-link", label: "Link" },
      { value: "bx bx-share", label: "Share" },
      { value: "bx bx-at", label: "At" },
    ],
  },
  {
    group: "Time & schedule",
    options: [
      { value: "bx bx-calendar", label: "Calendar" },
      { value: "bx bx-calendar-event", label: "Calendar event" },
      { value: "bx bx-calendar-check", label: "Calendar check" },
      { value: "bx bx-time", label: "Time" },
      { value: "bx bx-timer", label: "Timer" },
      { value: "bx bx-bell", label: "Bell" },
      { value: "bx bx-bell-off", label: "Bell off" },
    ],
  },
  {
    group: "Business & charts",
    options: [
      { value: "bx bx-briefcase", label: "Briefcase" },
      { value: "bx bx-buildings", label: "Buildings" },
      { value: "bx bx-building", label: "Building" },
      { value: "bx bx-bank", label: "Bank" },
      { value: "bx bx-landmark", label: "Landmark" },
      { value: "bx bx-store", label: "Store" },
      { value: "bx bx-store-alt", label: "Store alt" },
      { value: "bx bx-bar-chart", label: "Bar chart" },
      { value: "bx bx-line-chart", label: "Line chart" },
      { value: "bx bx-pie-chart", label: "Pie chart" },
      { value: "bx bx-chart", label: "Chart" },
      { value: "bx bx-trending-up", label: "Trending up" },
      { value: "bx bx-credit-card", label: "Credit card" },
      { value: "bx bx-wallet", label: "Wallet" },
      { value: "bx bx-dollar", label: "Dollar" },
      { value: "bx bx-gift", label: "Gift" },
      { value: "bx bx-award", label: "Award" },
      { value: "bx bx-certificate", label: "Certificate" },
      { value: "bx bx-badge", label: "Badge" },
    ],
  },
  {
    group: "Map & world",
    options: [
      { value: "bx bx-map", label: "Map" },
      { value: "bx bx-map-alt", label: "Map alt" },
      { value: "bx bx-map-pin", label: "Map pin" },
      { value: "bx bx-world", label: "World" },
      { value: "bx bx-globe", label: "Globe" },
      { value: "bx bx-navigation", label: "Navigation" },
    ],
  },
  {
    group: "Science & tools",
    options: [
      { value: "bx bx-aperture", label: "Aperture" },
      { value: "bx bx-flask", label: "Flask" },
      { value: "bx bx-test-tube", label: "Test tube" },
      { value: "bx bx-atom", label: "Atom" },
      { value: "bx bx-wrench", label: "Wrench" },
      { value: "bx bx-bug", label: "Bug" },
      { value: "bx bx-data", label: "Data" },
      { value: "bx bx-network-chart", label: "Network" },
      { value: "bx bx-server", label: "Server" },
      { value: "bx bx-cloud", label: "Cloud" },
      { value: "bx bx-cloud-upload", label: "Cloud upload" },
      { value: "bx bx-code", label: "Code" },
      { value: "bx bx-code-curly", label: "Code curly" },
      { value: "bx bx-cog", label: "Cog" },
      { value: "bx bx-cube", label: "Cube" },
    ],
  },
  {
    group: "UI & status",
    options: [
      { value: "bx bx-search", label: "Search" },
      { value: "bx bx-info-circle", label: "Info" },
      { value: "bx bx-error", label: "Error" },
      { value: "bx bx-error-circle", label: "Error circle" },
      { value: "bx bx-x-circle", label: "X circle" },
      { value: "bx bx-check", label: "Check" },
      { value: "bx bx-check-circle", label: "Check circle" },
      { value: "bx bx-help-circle", label: "Help" },
      { value: "bx bx-question-mark", label: "Question" },
      { value: "bx bx-star", label: "Star" },
      { value: "bx bx-heart", label: "Heart" },
      { value: "bx bx-thumbs-up", label: "Thumbs up" },
      { value: "bx bx-filter", label: "Filter" },
      { value: "bx bx-sort", label: "Sort" },
      { value: "bx bx-brightness", label: "Brightness" },
      { value: "bx bx-moon", label: "Moon" },
      { value: "bx bx-sun", label: "Sun" },
      { value: "bx bx-shield", label: "Shield" },
      { value: "bx bx-lock", label: "Lock" },
      { value: "bx bx-lock-open", label: "Lock open" },
      { value: "bx bx-key", label: "Key" },
      { value: "bx bx-trash", label: "Trash" },
      { value: "bx bx-pencil", label: "Pencil" },
      { value: "bx bx-download", label: "Download" },
      { value: "bx bx-upload", label: "Upload" },
    ],
  },
  {
    group: "Devices",
    options: [
      { value: "bx bx-laptop", label: "Laptop" },
      { value: "bx bx-desktop", label: "Desktop" },
      { value: "bx bx-mobile", label: "Mobile" },
      { value: "bx bx-hdd", label: "HDD" },
      { value: "bx bx-devices", label: "Devices" },
    ],
  },
  {
    group: "Solid (Boxicons bxs)",
    options: [
      { value: "bx bxs-home", label: "Home (solid)" },
      { value: "bx bxs-user", label: "User (solid)" },
      { value: "bx bxs-star", label: "Star (solid)" },
      { value: "bx bxs-heart", label: "Heart (solid)" },
      { value: "bx bxs-file", label: "File (solid)" },
      { value: "bx bxs-file-pdf", label: "PDF (solid)" },
      { value: "bx bxs-briefcase", label: "Briefcase (solid)" },
      { value: "bx bxs-building", label: "Building (solid)" },
      { value: "bx bxs-cog", label: "Cog (solid)" },
      { value: "bx bxs-bell", label: "Bell (solid)" },
      { value: "bx bxs-envelope", label: "Envelope (solid)" },
      { value: "bx bxs-phone", label: "Phone (solid)" },
      { value: "bx bxs-chevron-right", label: "Chevron right (solid)" },
      { value: "bx bxs-info-circle", label: "Info (solid)" },
      { value: "bx bxs-error", label: "Error (solid)" },
      { value: "bx bxs-check-shield", label: "Check shield (solid)" },
    ],
  },
];

export const SIDEBAR_ICON_PRESET_GROUPS = SIDEBAR_ICON_PRESET_GROUPS_INNER;

/** Flat list of every preset (for “known preset?” checks in the form). */
export const ALL_SIDEBAR_ICON_PRESET_OPTIONS = SIDEBAR_ICON_PRESET_GROUPS_INNER.flatMap(
  (g) => g.options
);

export const DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG = {
  template: "bureauVeritasPortal",
  hero: {
    enabled: true,
    title: "Bureau Veritas Information Portal",
    introHtml:
      'This portal is for the exclusive use of Bureau Veritas employees. It provides the resources you need to introduce ColdBlock digestion technology into your laboratory, including validated digestion methods using ColdBlock technology.<br /> <br /> Bureau Veritas began in-house testing of ColdBlock technology in <a href="https://coldblock.ca/press-releases/bureau-veritas-deploys-coldblock-digestion-technology-to-mining-customers-in-chile/" target="_blank" rel="noopener noreferrer">Chile in 2023</a>, transitioning from standard hot block digestion methods. Performance was evaluated for accuracy, precision, and repeatability, and following successful results, test work expanded to customer samples. Since then, ColdBlock is being implemented in Bureau Veritas laboratories worldwide. The resources contained within this portal will guide the introduction of ColdBlock into your lab.',
    videoUrl: "https://www.youtube.com/embed/R7mGHVSSdes?si=wstKHASGxw3mH0T8",
  },
  technology: {
    enabled: true,
    heading: "ColdBlock Digestion Technology",
    paragraphs: [
      "ColdBlock sample digestion technology is an innovative alternative to traditional digestion methods. ColdBlock uses focused short-wave infrared heating to dissolve solid sample matter into solution for multi-element analysis.",
      "The novel cooling zone creates a condensation effect which retains more of the sample. The outcome is faster, safer digestions that deliver accurate, repeatable results.",
      "ColdBlock’s sample digestion technology is used in laboratories across several industries, including metals and mining, food and agriculture, and environmental testing.",
    ],
  },
  highlightBand: {
    enabled: false,
    backgroundColor: "#f1f1f1",
    headerHtml: "ColdBlock<br />and SGS",
    bodyHtml:
      "SGS has been testing and validating ColdBlock digestion technology since 2024. Standard digestion methods have been transitioned to ColdBlock, and performance has been evaluated for accuracy, precision and repeatability. After confirming these results, digestions using the ColdBlock method have been added to client service offerings.",
  },
  quoteHighlights: {
    enabled: false,
    quoteHtml:
      '<p><em>&ldquo;The adoption of ColdBlock <a href="https://www.engineeringnews.co.za/topic/technology" target="_blank" rel="noopener noreferrer">technology</a> marks a major milestone in our commitment to <a href="https://www.engineeringnews.co.za/topic/innovation" target="_blank" rel="noopener noreferrer">innovation</a> and excellence. It allows us to deliver superior quality results with faster turnaround times, while ensuring a safer and more <a href="https://www.engineeringnews.co.za/topic/sustainable" target="_blank" rel="noopener noreferrer">sustainable</a> working <a href="https://www.engineeringnews.co.za/topic/environment" target="_blank" rel="noopener noreferrer">environment</a>.&rdquo;</em></p><p><strong>Dr. Ljiljana Marjanovic, SGS Chief Chemist for Geochemistry</strong></p>',
    bodyHtml:
      "Since then, ColdBlock has been successfully implemented in 6 SGS laboratories worldwide. The benefits of this transition have been substantial, paving the way for a global service agreement, under which we are now launching this portal. Some highlights of our work together include:",
    highlights: [
      'ColdBlock is pleased to be featured in the <a href="https://online.flippingbook.com/view/6967241/" target="_blank" rel="noopener noreferrer">2026 SGS Geochemistry Guide</a>.',
      "ColdBlock was featured in a presentation given by Dr. Ljiljana Marjanovic at the Mining with SGS in Cape Town, South Africa in February 2026.",
      'SGS work with ColdBlock was featured in an article published in <a href="https://www.engineeringnews.co.za/article/sgs-pioneers-coldblock-technology-in-geochemistry-laboratories-2025-07-03" target="_blank" rel="noopener noreferrer">Engineering News</a>.',
    ],
    imageUrl: "",
    imageKey: "",
    imageAlt: "Laboratory technician using ColdBlock technology",
  },
  lab: {
    enabled: true,
    heading: "The ColdBlock R&D Lab",
    intro:
      "The ColdBlock R&D Lab regularly publishes Application Notes that demonstrate the accurate results achieved using ColdBlock sample digestion technology. Application Notes for a wide variety of sample types can be found on the ColdBlock website:",
    cards: [
      {
        label: "Food & Agriculture",
        href: "https://coldblock.ca/resources/food-agriculture",
        imageUrl: plantingIcon,
        imageAlt: "Food & Agriculture",
      },
      {
        label: "Mining & Metals",
        href: "https://coldblock.ca/resources/mining-metals",
        imageUrl: mineIcon,
        imageAlt: "Mining & Metals",
      },
      {
        label: "Environmental",
        href: "https://coldblock.ca/resources/environment",
        imageUrl: saveTheWorldIcon,
        imageAlt: "Environmental",
      },
    ],
    contactIntro:
      "For assistance with sample testing, method optimization, more information on a sample type, or the transition from current digestion processes, please contact:",
    contacts: [
      {
        email: "ladoig@coldblock.ca",
        name: "Lorie-Anne Doig",
        title: "Director, Laboratory Services",
      },
      {
        email: "mpalomba@coldblock.ca",
        name: "Matthew Palomba",
        title: "Laboratory Analyst",
      },
    ],
  },
  importantContacts: {
    enabled: true,
    heading: "Important Contacts",
    leftTitle: "ColdBlock",
    leftContacts: [
      {
        email: "kmoffatt@coldblock.ca",
        name: "Kathy Moffatt",
        title: "VP, Sales",
        organization: "ColdBlock Technologies Inc.",
      },
      {
        email: "ladoig@coldblock.ca",
        name: "Lorie-Anne Doig",
        title: "Director, Laboratory Services",
        organization: "ColdBlock Technologies Inc.",
      },
      {
        email: "mpalomba@coldblock.ca",
        name: "Matthew Palomba",
        title: "Laboratory Analyst",
        organization: "ColdBlock Technologies Inc.",
      },
    ],
    rightTitle: "Bureau Veritas",
    rightContacts: [
      {
        email: "michael.dunning@bureauveritas.com",
        name: "Michael Dunning",
        title: "Minerals Technical and Quality Director Bureau Veritas",
      },
      {
        email: "ielisson.amorim@bureauveritas.com",
        name: "Ielisson Melio de Amorim",
        title: "Group Procurement Director",
        organization: "Bureau Veritas",
      },
    ],
  },
  support: {
    enabled: true,
    resourcesHeading: "Overview of Resources Available",
    resourcesBodyHtml:
      'To view the list of resources available in this portal, please visit our <a href="/resources" class="text-portal-blue">Resources Directory</a>.',
    supportHeading: "How to Order and Access Support",
    supportItems: [
      'For product assistance or questions, please contact <a href="mailto:info@coldblock.ca" class="text-portal-blue">info@coldblock.ca</a>.',
      'For technical assistance, please contact <a href="mailto:portalsupport@armadawebsolutions.com" class="text-portal-blue">portalsupport@armadawebsolutions.com</a>.',
    ],
  },
  linkColumns: {
    enabled: false,
    heading: "SGS Locations Currently Using ColdBlock",
    leftLinks: [
      {
        label: "SGS Chile",
        href: "https://www.sgs.com/en-za/office-directory?City=&Location=&searchKey=Pudahuel",
      },
      {
        label: "SGS Democratic Republic of Congo",
        href: "https://www.sgs.com/en-za/office-directory?City=&Location=&searchKey=congo%20pointe-noire",
      },
      {
        label: "SGS Canada (Lakefield)",
        href: "https://www.sgs.com/en-za/office-directory?City=&Location=Canada&searchKey=Lakefield",
      },
      {
        label: "SGS Mali",
        href: "https://www.sgs.com/en-za/office-directory?City=&Location=&searchKey=BAmako",
      },
    ],
    rightLinks: [
      {
        label: "SGS Australia (Perth)",
        href: "https://www.sgs.com/en-za/office-directory?City=&Location=&searchKey=Perth",
      },
      {
        label: "SGS Shanghai",
        href: "https://www.sgs.com/en/office-directory/sgs-china-shanghai-kangqiao-road-building-5-office",
      },
      {
        label: "SGS South Africa",
        href: "https://www.sgs.com/en-za/office-directory?Location=South%20Africa",
      },
    ],
  },
};

/** Bundled default lab card image URLs — hide these in the company admin form preview until the user uploads a replacement. */
export const DEFAULT_LAB_CARD_IMAGE_URLS = new Set(
  DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.lab.cards.map((c) => c.imageUrl).filter(Boolean)
);

/** True when the feature-card preview should show (user upload or non-default image URL). */
export const shouldShowLabCardImagePreview = (card) => {
  if (!card?.imageUrl) return false;
  if (card.imageKey) return true;
  return !DEFAULT_LAB_CARD_IMAGE_URLS.has(String(card.imageUrl));
};

const isObject = (value) => !!value && typeof value === "object" && !Array.isArray(value);

export const sanitizePortalHtml = (value) => {
  if (!value) return "";
  return String(value)
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/\son[a-z]+\s*=\s*(['"]).*?\1/gi, "")
    .replace(/\son[a-z]+\s*=\s*[^\s>]+/gi, "")
    .replace(/javascript:/gi, "");
};

const mergeSection = (defaults, overrides) => ({
  ...defaults,
  ...(isObject(overrides) ? overrides : {}),
});

const mergeArray = (fallback, next) => (Array.isArray(next) ? next : fallback);

export const mergePortalConfig = (config) => {
  const next = isObject(config) ? config : {};
  return {
    template: "bureauVeritasPortal",
    hero: mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.hero, next.hero),
    technology: {
      ...mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.technology, next.technology),
      paragraphs: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.technology.paragraphs,
        next?.technology?.paragraphs
      ),
    },
    highlightBand: mergeSection(
      DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.highlightBand,
      next.highlightBand
    ),
    quoteHighlights: {
      ...mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.quoteHighlights, next.quoteHighlights),
      highlights: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.quoteHighlights.highlights,
        next?.quoteHighlights?.highlights
      ),
    },
    lab: {
      ...mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.lab, next.lab),
      cards: mergeArray(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.lab.cards, next?.lab?.cards),
      contacts: mergeArray(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.lab.contacts, next?.lab?.contacts),
    },
    importantContacts: {
      ...mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.importantContacts, next.importantContacts),
      leftContacts: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.importantContacts.leftContacts,
        next?.importantContacts?.leftContacts
      ),
      rightContacts: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.importantContacts.rightContacts,
        next?.importantContacts?.rightContacts
      ),
    },
    support: {
      ...mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.support, next.support),
      supportItems: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.support.supportItems,
        next?.support?.supportItems
      ),
    },
    linkColumns: {
      ...mergeSection(DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.linkColumns, next.linkColumns),
      leftLinks: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.linkColumns.leftLinks,
        next?.linkColumns?.leftLinks
      ),
      rightLinks: mergeArray(
        DEFAULT_BUREAU_VERITAS_PORTAL_CONFIG.linkColumns.rightLinks,
        next?.linkColumns?.rightLinks
      ),
    },
  };
};

const SIDEBAR_ICON_CLASS_RE = /^(bx|bxs)(\s+(bx|bxs)-[a-z0-9-]+)+$/;

const defaultIconClassForSidebarItem = (item) => {
  if (!item) return "bx bx-home";
  if (item.type === "scroll") {
    return item.scrollTarget === "support-info" ? "bx bx-help-circle" : "bx bx-message";
  }
  if (item.type === "external") return "bx bx-link-external";
  if (item.path === "/resources") return "bx bx-aperture";
  return "bx bx-home";
};

/**
 * Resolved Boxicons `<i className>` value for a role-3 sidebar item.
 * Uses `item.iconClass` when it matches the Boxicons pattern; otherwise the legacy default by type/path.
 */
export const getSidebarItemIconClass = (item) => {
  const raw = item?.iconClass;
  if (typeof raw === "string") {
    const compact = raw.replace(/\s+/g, " ").trim();
    if (compact && SIDEBAR_ICON_CLASS_RE.test(compact)) return compact;
  }
  const fromDefaults = DEFAULT_ROLE3_SIDEBAR_ITEMS.find((d) => d.id === item?.id)?.iconClass;
  if (fromDefaults && SIDEBAR_ICON_CLASS_RE.test(fromDefaults)) return fromDefaults;
  return defaultIconClassForSidebarItem(item);
};

export const getRole3SidebarItems = (sidebarConfig) => {
  const items = Array.isArray(sidebarConfig?.items) && sidebarConfig.items.length
    ? sidebarConfig.items
    : DEFAULT_ROLE3_SIDEBAR_ITEMS;

  return items
    .filter((item) => item?.enabled !== false)
    .slice()
    .sort((a, b) => Number(a?.sortOrder ?? 0) - Number(b?.sortOrder ?? 0));
};

/** Slug pattern for portal custom pages (kebab-case segments). */
const CUSTOM_PAGE_SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

const HOME_CUSTOM_PAGE_PATH_RE = /^\/home\/([^/]+)$/i;

/**
 * Returns a safe array for `customPages` API payloads.
 * `null`, `undefined`, and non-arrays normalize to `[]`. Array inputs return a shallow copy
 * so callers can mutate the returned list without affecting the source reference.
 */
export const getCustomPages = (customPages) =>
  Array.isArray(customPages) ? customPages.slice() : [];

/**
 * Trims, lowercases, and validates a custom page slug for editor preview.
 * Returns an empty string when the value is missing or does not match {@link CUSTOM_PAGE_SLUG_RE}.
 */
export const normalizeCustomPageSlug = (value) => {
  if (value == null) return "";
  const next = String(value).trim().toLowerCase();
  if (!next || !CUSTOM_PAGE_SLUG_RE.test(next)) return "";
  return next;
};

/** `/home/<slug>` when slug is non-empty after normalization; otherwise an empty string. */
export const getCustomPageRoute = (slug) => {
  const normalized = normalizeCustomPageSlug(slug);
  if (!normalized) return "";
  return `/home/${normalized}`;
};

export const findCustomPageBySlug = (customPages, slug) => {
  const target = normalizeCustomPageSlug(slug);
  if (!target) return undefined;
  return getCustomPages(customPages).find(
    (page) => normalizeCustomPageSlug(page?.slug) === target
  );
};

export const getCustomPageSidebarWarnings = (customPages, sidebarItems) => {
  const pages = getCustomPages(customPages);
  const pageSlugs = new Set(
    pages.map((p) => normalizeCustomPageSlug(p?.slug)).filter(Boolean)
  );

  const items = Array.isArray(sidebarItems) ? sidebarItems : [];
  const missingSet = new Set();
  const linkedSlugs = new Set();

  for (const item of items) {
    if (item?.enabled === false || item?.type !== "route") continue;
    const path = item.path;
    if (typeof path !== "string") continue;
    const trimmed = path.trim();
    const match = HOME_CUSTOM_PAGE_PATH_RE.exec(trimmed);
    if (!match) continue;
    const slug = normalizeCustomPageSlug(match[1]);
    if (!slug) continue;
    linkedSlugs.add(slug);
    if (!pageSlugs.has(slug)) missingSet.add(trimmed);
  }

  const unlinkedSlugs = [...pageSlugs].filter((slug) => !linkedSlugs.has(slug)).sort();

  return {
    missingPageRoutes: [...missingSet].sort(),
    unlinkedSlugs,
  };
};

/**
 * Pure view decision for role-3 portal routing by custom page slug.
 * Does not interpret `portalCustomHtml*`; Dashboard applies HTML override separately.
 */
export const resolveRole3PortalView = ({ slug, customPages }) => {
  const normalizedSlug = normalizeCustomPageSlug(slug ?? "");
  if (!normalizedSlug) {
    return { mode: "home" };
  }

  const page = findCustomPageBySlug(customPages, normalizedSlug);
  if (page) {
    const raw = page.html == null ? "" : String(page.html);
    return { mode: "custom-page", html: raw.trim(), documentIds: normalizeDocumentIds(page?.documentIds) };
  }

  return { mode: "redirect-home" };
};
